import { render, staticRenderFns } from "./EventItem3.vue?vue&type=template&id=41927d70"
import script from "./EventItem3.vue?vue&type=script&lang=ts"
export * from "./EventItem3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports